import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import './components';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import store from './store';
import errorCode from './store/errorCode.json'
import api from './api';
import moment from 'moment';
import vueMoment from 'vue-momentjs';
import naverMap from './plugins/naverMap';
import checkBox from './plugins/checkbox';
import cors from 'cors';
import CKEditor from 'ckeditor4-vue';
import globalFunc from './plugins/globalFunc';

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$event = new Vue();
Vue.prototype.$errorCode = errorCode;
Vue.prototype.$func = globalFunc;

Vue.use( CKEditor );
Vue.use(vueMoment, moment);
Vue.use(globalFunc);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

